import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Container } from "react-bootstrap";
import Listing from "./Listing";
import { useDispatch, useSelector } from "react-redux";
import { allUserList, approveOrRejectUser, reqToBankUsersStats, updateBankUserStatus, reqToChangePassword } from "../../../redux/slice/userSlice";
import { useLoader } from "../../../context/LoaderContext";
import AddUserModal from "../../../components/modals/AddUserModal";
import PasswordChangeModal from "../../../components/modals/PasswordChangeModal";
import { useToast } from "../../../context/TostContext";
import { ApprovedUser, RejectedUser, ReqUserIcon, UserIcon } from "../../../assets/icons";
import ConfirmModal from "../../../components/withModal/ConfirmModal";
import { usePermission } from "../../../hooks/usePermission";
import { TabCard } from "../../../components/custom-card/Cards";

const MODULE_SLUG = "bank_users";

const BankUsers = () => {
  const dispatch = useDispatch();
  const { setLoading } = useLoader();
  const { hasPermission } = usePermission();
  const headerPortalTarget = document.getElementById("header-portal-target");

  const headerContent = (
    <div className="d-flex align-items-center justify-content-between w-100">
      <h4 className="fw-semibold mb-0 text-primary fs-lg">
        <span className="text-muted fw-normal">User Details / </span>Bank Users
      </h4>
    </div>
  );

  const canCreate = hasPermission(MODULE_SLUG, "create");
  const canUpdate = hasPermission(MODULE_SLUG, "update");
  const canExport = hasPermission(MODULE_SLUG, "export");
  const canVerify = hasPermission(MODULE_SLUG, "verify");
  const toast = useToast();
  // Pagination
  const [
    limit,
    setLimit
  ] = useState({ value: 10, label: 10 });
  const [currentPage, setCurrentPage] = useState(1);
  // Open Add User Modal
  const [openAddUserModal, setOpenAddUserModal] = useState(false);
  // Open ChangePassword Modal
  const [openChangePwModal, setOpenChangePwModal] = useState(false);
  const [changePasswordId, setChangePasswordId] = useState("");
  // Card Status
  const [cardStatus, setCardStatus] = useState("");
  // Search Bar
  const [searchTerm, setSearchTerm] = useState("");

  // Status Modal
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [modalItem, setModalItem] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const [editUserData, setEditUserData] = useState(null);
  // console.log("cardStatus",cardStatus);

  // const {users = [], statusCounts = {}, totalUsers = 0} = useSelector((state) => state?.user?.allUser?.data || []);
  // const users = useSelector((state) => state?.user?.allUser|| []); 
  const { allUser: users = [], isLoading } = useSelector((state) => state?.user || {});
  const totalUsers = useSelector((state) => state?.user?.meta?.total || []);
  const stats = useSelector((state) => state?.user?.bankUsersStats || []);
  console.log("isLoading", isLoading);
  console.log("users", users);
  // console.log("Status Counts:", statusCounts);
  // console.log("Total Users:", totalUsers);

  const AllTypesOfUserCard = [
    {
      id: 1,
      total: stats?.data?.total_users || 0,
      title: "Total User",
      icon: <UserIcon size={24} />,
      status: "",
      iconClassName: "icon-secondary"
    },
    {
      id: 2,
      total: stats?.data?.pending_users || 0,
      title: "Requested User",
      icon: <ReqUserIcon size={24} />,
      status: "pending",
      iconClassName: "icon-warning"
    },
    {
      id: 3,
      total: stats?.data?.approved_users || 0,
      title: "Approved User",
      icon: <ApprovedUser size={24} />,
      status: "approved",
      iconClassName: "icon-success"
    },
    {
      id: 4,
      total: stats?.data?.rejected_users || 0,
      title: "Rejected User",
      icon: <RejectedUser size={24} />,
      status: "rejected",
      iconClassName: "icon-danger"
    },
  ];


  // status handler based on Card Click (APi will get call and display list based on status)
  const handleCardClick = (status) => {
    setCardStatus(status);
    setCurrentPage(1);
  };

  // Open Add User Modal
  const addUserHandler = () => {
    setIsEditMode(false);
    setIsViewMode(false);
    setEditUserData(null);
    setOpenAddUserModal(true);
  };

  const handleChangePassword = (item) => {
    setChangePasswordId(item);
    setOpenChangePwModal(true);
  };

  const handleStatusToggle = (item) => {
    setModalItem(item);
    setShowStatusModal(true);
  };

  const handleEdit = (item) => {
    console.log("ITEMSSSS", item);

    setEditUserData(item);
    setIsEditMode(true);
    setIsViewMode(false);
    setOpenAddUserModal(true);
  };

  const handleView = (item) => {
    setEditUserData(item);
    setIsEditMode(false);
    setIsViewMode(true);
    setOpenAddUserModal(true);
  };

  const confirmStatusChange = () => {
    if (!modalItem) return;

    setLoading(true);
    dispatch(
      updateBankUserStatus({
        id: modalItem.id,
        is_active: !modalItem.is_active,
      })
    )
      .then((res) => {
        if (res?.payload?.success) {
          toast.success(res?.payload?.message || "Status updated successfully");
          dispatch(allUserList({ status: cardStatus, page: currentPage, limit: limit?.value, search: searchTerm }));
          dispatch(reqToBankUsersStats());
        } else {
          toast.error(res?.payload?.message || "Failed to update status");
        }
      })
      .catch((err) => {
        toast.error(err?.message || "Something went wrong");
      })
      .finally(() => {
        setLoading(false);
        setShowStatusModal(false);
        setModalItem(null);
      });
  };

  // Approve or Reject User
  const handleUserApproveOrReject = (type, item) => {
    try {
      const id = item?.id;
      if (type && id) {
        setLoading(true);
        const data = { status: type };
        dispatch(approveOrRejectUser({ data, id })).then((res) => {
          toast.success(res?.payload.message || "User status updated successfully!");
          if (res?.payload?.success) {
            dispatch(allUserList({ status: cardStatus, page: currentPage }));
            dispatch(reqToBankUsersStats());
          }
        });
      } else {

        toast.error("User status or Id Missing!");
      }
    } catch (err) {
      setLoading(false);
      const errorMessage = err?.message || "Failed to update user status!";

      toast.error(errorMessage);
    } finally {
      setLoading(false);

    }
  };

  // const [isInitialLoad, setIsInitialLoad] = useState(true);
  const isInitialLoadRef = useRef(true);
  const searchTimeout = useRef(null);

  // Debounced Search Handler
  // const handleSearch = useCallback(() => {
  //   if (searchTimeout.current) {
  //     clearTimeout(searchTimeout.current);
  //   }

  //   searchTimeout.current = setTimeout(() => {
  //     // console.log("SEARCH API...");  
  //     dispatch(allUserList({ search: searchTerm, page: currentPage, status: cardStatus, }));
  //   }, 300); // 300ms delay for better UX
  // }, [searchTerm,currentPage,cardStatus, dispatch]);

  // Trigger API Call when search or page changes
  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    const fetchData = () => {
      if (isInitialLoadRef.current) {
        setLoading(true);
      }

      dispatch(
        allUserList({
          search: searchTerm,
          page: currentPage,
          status: cardStatus,
          limit: limit?.value,
        })
      ).finally(() => {
        if (isInitialLoadRef.current) {
          setLoading(false);
          isInitialLoadRef.current = false;
        }
      });

      dispatch(reqToBankUsersStats());
    };

    if (isInitialLoadRef.current) {
      fetchData();
    } else {
      searchTimeout.current = setTimeout(fetchData, 300);
    }

    return () => {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
      }
    };
  }, [
    dispatch,
    searchTerm,
    currentPage,
    cardStatus,
    limit?.value,
    setLoading,
  ]);

  // // Api Call for Search
  // // useEffect(() => {
  // //   const delayTimeout = setTimeout(() => {
  // //       dispatch(allUserList({ search: searchTerm }));
  // //   }, 3000); // 3 second delay

  // //   return () => clearTimeout(delayTimeout);
  // // }, [searchTerm, dispatch]); 

  // // Api Call for All Users
  // const getAllUsersData = useCallback(() => {
  //   setLoading(true);
  //   // console.log("MAIN API...");
  //   dispatch(
  //     allUserList({
  //       status: cardStatus,
  //       page: currentPage,
  //       limit: limit?.value,
  //     })
  //   )
  //     .then(() => {
  //       setLoading(false);
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // }, [dispatch, cardStatus, limit?.value, currentPage, setLoading]);

  // useEffect(() => {
  //   getAllUsersData();
  // }, [getAllUsersData]);

  useEffect(() => {
    dispatch(reqToBankUsersStats());
  }, [dispatch])



  return (
    <>
      {headerPortalTarget && createPortal(headerContent, headerPortalTarget)}
      <Container fluid className="px-0">
        {/* Card Section */}
        <div className="grid gap-4">
          {AllTypesOfUserCard?.map((item, i) => (
            <TabCard
              key={i}
              count={item?.total}
              title={item?.title}
              className="g-col-4 g-col-xxl-3"
              icon={item?.icon}

              active={item.status === cardStatus}

              onClick={() => handleCardClick(item?.status)}
              iconClassName={item?.iconClassName}
            />
          ))}
        </div>

        <div className="bg-white rounded-2 overflow-hidden common-shadow mt-4">
          <Listing
            data={users}
            isLoading={isLoading}
            searchTerm={searchTerm}
            setCurrentPage={setCurrentPage}
            setSearchTerm={setSearchTerm}
            addUserHandler={addUserHandler}
            handleStatusToggle={handleStatusToggle}
            handleEdit={handleEdit}
            handleView={handleView}
            handleChangePassword={handleChangePassword}
            handleUserApproveOrReject={handleUserApproveOrReject}
            cardStatus={cardStatus}
            canCreate={canCreate}
            canUpdate={canUpdate}
            canExport={canExport}
            canVerify={canVerify}
            pagination={{
              currentPage,
              totalPages: Math.ceil((totalUsers || 0) / (limit?.value || 10)),
              total: totalUsers || 0,
              onPageChange: (page) => setCurrentPage(page),
              pageSize: limit?.value || 10,
              setPageSize: (size) => {
                setLimit({ value: size, label: size });
                setCurrentPage(1);
              },
              setCurrentPage,
              perPageOptions: [10, 20, 50, 100],
            }}
          />

          {openChangePwModal && (
            <PasswordChangeModal
              isOpen={openChangePwModal}
              onClose={() => {
                setOpenChangePwModal(false);
                setChangePasswordId("");
              }}
              onSubmit={async (newPassword) => {
                const data = {
                  new_password: newPassword,
                  confirm_password: newPassword,
                };
                await dispatch(reqToChangePassword({ data, id: changePasswordId?.id })).unwrap();
                dispatch(allUserList({ status: cardStatus, page: currentPage, limit: limit?.value }));
              }}
              title="Change Password"
            />
          )}
          {/* Add User Modal */}
          <AddUserModal
            isOpen={openAddUserModal}
            onClose={() => {
              setOpenAddUserModal(false);
              setIsEditMode(false);
              setIsViewMode(false);
              setEditUserData(null);
            }}
            cardStatus={cardStatus}
            currentPage={currentPage}
            limit={limit}
            isEdit={isEditMode}
            isView={isViewMode}
            userData={editUserData}
            size="md"
            title={isViewMode ? "View User" : isEditMode ? "Update User" : "Create New User"}
          />

          {/* Status Confirmation Modal */}
          <ConfirmModal
            isOpen={showStatusModal}
            onClose={() => {
              setShowStatusModal(false);
              setModalItem(null);
            }}
            title={modalItem?.is_active ? "Deactivate User" : "Activate User"}
            message={
              modalItem?.is_active
                ? "Do you want to inactive?"
                : "Do you want to active?"
            }
            onConfirm={confirmStatusChange}
          />
        </div>
      </Container>
    </>
  );
};

export default BankUsers;
